import React from 'react';
import { FullWrap, FooterTopWrap, LinkWrap, FooterLink, RightWrap, ContactButton, IconsWrap, IconItem, FooterBottomWrap, BottomLinkWrap, BottomFooterLink } from './styles';
import { FaFacebookF, FaInstagram, FaYoutube, FaLinkedinIn } from 'react-icons/fa';

const Footer = () => {
    return (
        <FullWrap >
            <FooterTopWrap>
                <a href="/" className="logo"><img src="/images/logo-footer.svg" alt="" /></a>
                <LinkWrap>
                    <FooterLink href="/" className="active">
                        Corporate
                    </FooterLink>
                    <FooterLink href="/">
                        Healthcare Professionals
                    </FooterLink>
                    <FooterLink href="/">
                        Patients
                    </FooterLink>
                </LinkWrap>
                <LinkWrap>
                    <FooterLink href="/" className="active">
                        About Axonics
                    </FooterLink>
                    <FooterLink href="/">
                        Investor Relations
                    </FooterLink>
                    <FooterLink href="/">
                        Careers
                    </FooterLink>
                    <FooterLink href="/">
                        Contact Us
                    </FooterLink>
                </LinkWrap>
                <RightWrap>
                    <ContactButton href="/">Contact Us</ContactButton>
                    <IconsWrap>
                        <IconItem>
                            <a href=""><FaFacebookF /></a>
                        </IconItem>
                        <IconItem>
                            <a href=""><FaInstagram /></a>
                        </IconItem>
                        <IconItem>
                            <a href=""><FaYoutube /></a>
                        </IconItem>
                        <IconItem>
                            <a href=""><FaLinkedinIn /></a>
                        </IconItem>
                    </IconsWrap>
                </RightWrap>
            </FooterTopWrap>
            <FooterBottomWrap>
                <p>©2019 Axonics Modulation Technologies, Inc. Axonics<sup>®</sup> and Axonics Modulation Technologies<sup>®</sup> are trademarks of Axonics Modulation Technologies, Inc., registered or pending registration in the U.S. and other countries.</p>
                <BottomLinkWrap>
                    <BottomFooterLink href="/">
                        Privacy Policy
                    </BottomFooterLink>
                    <BottomFooterLink href="/">
                        Terms of Use
                    </BottomFooterLink>
                    <BottomFooterLink href="/">
                        Important Safety Information
                    </BottomFooterLink>
                    <BottomFooterLink href="/">
                        Sitemap
                    </BottomFooterLink>
                    <BottomFooterLink href="/" style={{border:"none"}}>
                        myAxonics Portal
                    </BottomFooterLink>
                </BottomLinkWrap>
            </FooterBottomWrap>
        </FullWrap>
    );
}

export default Footer;


// WEBPACK FOOTER //
// ./src/component/Footer/index.js